import React from 'react';
import { useMetaMenuLinks } from './hooks/use-meta-menu-links';
import { MetaMenuLink } from './components/meta-menu-link';
import { getNavSideBarItemTransitionDelay } from '../nav-drawer/helpers/get-nav-side-bar-item-transition-delay';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export var NavSidebarMetaMenu = function NavSidebarMetaMenu(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      transitionDelayOffset = _ref.transitionDelayOffset;
  var metaMenuLinks = useMetaMenuLinks();

  if (!metaMenuLinks.userLinks.length) {
    return null;
  }

  return /*#__PURE__*/_jsx("div", {
    className: "d-flex flex-column mt-auto gap-100 pt-300 pb-400",
    children: metaMenuLinks.userLinks.map(function (_ref2, index) {
      var variant = _ref2.variant,
          link = _ref2.link;
      return /*#__PURE__*/_jsx(MetaMenuLink, {
        className: classNames('text-center btn-lg', className),
        variant: variant,
        link: link,
        style: {
          transitionDelay: getNavSideBarItemTransitionDelay(transitionDelayOffset + index)
        }
      }, link === null || link === void 0 ? void 0 : link.path);
    })
  });
};